import { Box, Card, CardBody, CardHeader, Heading, Text } from '@chakra-ui/react'
import { useNavigate } from 'react-router-dom'
import { ChildTicketStatusForm } from '@/components/forms/ChildTicketStatusForm'
import { useThemeColors } from '@/hooks/useThemeColors'

export default function ChildTicketStatusCreatePage() {
  const colors = useThemeColors()
  const navigate = useNavigate()

  const handleSuccess = () => {
    navigate('/service-catalog/child-ticket-statuses')
  }

  const handleCancel = () => {
    navigate('/service-catalog/child-ticket-statuses')
  }

  return (
    <Box p={4} h="full" overflow="hidden" display="flex" flexDirection="column">
      <Box minW={0} display="flex" flexDirection="column" overflow="hidden" flex="1">
        <Card h="full" display="flex" flexDirection="column">
          <CardHeader flexShrink={0}>
            <Heading size="md">Create Task Status</Heading>
            <Text fontSize="sm" color={colors.text} mt={1}>
              Add a new task status to the catalog
            </Text>
          </CardHeader>
          <CardBody overflowY="auto" flex="1" minH={0}>
            <ChildTicketStatusForm onSuccess={handleSuccess} onCancel={handleCancel} />
          </CardBody>
        </Card>
      </Box>
    </Box>
  )
}
